<script>
    import ClassName from './ClassNameComponent.svelte';
    import TeacherName from './TeacherNameComponent.svelte';
    import TimeShower from './TimeShowerComponent.svelte';
    import SendEmailLink from './RecieveEmailComponent.svelte';
    import ButtonToJoinClass from './ButtonToJoinClassComponent.svelte'
    import { push } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import ButtonToJoinClassComponent from './ButtonToJoinClassComponent.svelte';
    import FilterButtons from './FilterButtons.svelte'; // Import your component
    import RescheduleButton from './ButtonToRescheduleComponent.svelte'
    import ButtonToComment from './ButtonToLeaveCommentComponent.svelte'
    import NavBarReusable from './NavbarReusable.svelte';
    import RescheduleRequestsContent from './RescheduleRequestsContent.svelte';
    import TeacherRegistrationRequestsComponent from './TeacherRegistrationRequestsComponent.svelte';
    import StudentsWithGradesComponent from './StudentsWithGradesComponent.svelte';
    import TeacherPersonalNotesPanel from './TeacherPersonalNotesPanel.svelte';
    import { tick } from 'svelte';
    let notesEventId = null;
    let notesPanel;
    let notesTrigger;
    async function openPersonalNotes(event, trigger) {
      if (notesEventId && !await notesPanel.requestClose()) return;
      await tick();
      notesTrigger = trigger;
      notesEventId = event.id;
    }
    async function closePersonalNotes() {
      notesEventId = null;
      await tick();
      notesTrigger?.focus();
    }
    function personalNoteChanged(event) {
      events = events.map(row => row.id === event.detail.eventId ? { ...row, has_personal_note: event.detail.exists } : row);
    }
    let events = [];
    let currentFilter = 'past_classes';
    let isUserTeacher = false;
    let isLoadingEvents = true;
    let scheduleError = '';
    let activeTab = 'schedule'; // 'schedule', 'reschedule-requests', or 'registration-requests'
    let unacceptedRequestsCount = 0;
    let unacceptedRescheduleRequestsCount = 0;
    
    // Function to switch between tabs
    async function switchTab(tab) {
        if (notesEventId && !await notesPanel.requestClose()) return;
        activeTab = tab;
        // Refresh counts when switching away from specific tabs
        if (tab !== 'registration-requests' && isUserTeacher) {
            fetchUnacceptedRequestsCount();
        }
        if (tab !== 'reschedule-requests') {
            fetchUnacceptedRescheduleRequestsCount();
        }
    }

    // Function to fetch unaccepted registration requests count
    const fetchUnacceptedRequestsCount = async () => {
        if (!isUserTeacher) return;
        
        const token = localStorage.getItem('jwtToken');
        try {
            const response = await fetch('/studentplayground/api/teacher/class-registration-requests/', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            if (response.ok) {
                const data = await response.json();
                let count = 0;
                
                // Count unaccepted requests across all days
                Object.values(data).forEach(dayRequests => {
                    dayRequests.forEach(req => {
                        if (!req.accepted_by_teacher) {
                            count++;
                        }
                    });
                });
                
                unacceptedRequestsCount = count;
            }
        } catch (error) {
            console.error('Error fetching registration requests count:', error);
        }
    };

    // Function to fetch unaccepted reschedule requests count
    const fetchUnacceptedRescheduleRequestsCount = async () => {
        const token = localStorage.getItem('jwtToken');
        try {
            const response = await fetch('/studentplayground/api/reschedule-requests-count/', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            if (response.ok) {
                const data = await response.json();
                unacceptedRescheduleRequestsCount = data.pending_count;
            }
        } catch (error) {
            console.error('Error fetching reschedule requests count:', error);
        }
    };

    
    // Function to change the link text when clicked
    function changeLinkText(event) {
      const link = event.target;
      link.textContent = "Pamokos informacija išsiųsta!";
    }
    function hasClassStarted(eventTime) {
      const match = eventTime.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2})/);
      if (!match) return false;

      const startTime = new Date(`${match[1]}T${match[2]}:00`);
      const nowInLithuania = new Date(new Date().toLocaleString("sv-SE", { timeZone: "Europe/Vilnius" }));
      return startTime <= nowInLithuania;
    }

    function isPastEvent(eventTime) {
      console.log("THis is the event time RAW");
      console.log(eventTime);
      
      // Format the event time to get the CLASS END TIME (not start time)
      const validEventTime = formatEventTime(eventTime)
      
      console.log("Event END time formatted:", validEventTime);
      
      if (!validEventTime) {
        console.error("Could not parse event time:", eventTime);
        return false; // Default to not past if we can't parse
      }
      
      try {
        // Parse the Lithuanian time string and create Date objects in Lithuanian timezone
        const [datePart, timePart] = validEventTime.split('T');
        
        // Create event date by treating the input as Lithuanian timezone
        // We need to parse it and then convert to UTC for accurate comparison
        const eventDateTime = new Date(validEventTime);
        
        // The key insight: the backend provides time in Lithuanian timezone, 
        // but JavaScript Date constructor treats it as local timezone
        // So we need to adjust for the difference
        
        // Get current time in Lithuanian timezone
        const now = new Date();
        const nowInLithuaniaStr = now.toLocaleString("sv-SE", { timeZone: "Europe/Vilnius" });
        const nowInLithuania = new Date(nowInLithuaniaStr);
        
        // Create event time in Lithuanian timezone using the same method
        const eventInLithuaniaStr = validEventTime.replace('T', ' ');
        const eventInLithuania = new Date(eventInLithuaniaStr);
        
        // Add 10-minute buffer for both teachers and students - they can leave comments 10 minutes before class ends
        // This allows both to submit feedback if they finish early
        const bufferMinutes = 10; // Apply 10-minute buffer for everyone
        const eventWithBuffer = new Date(eventInLithuania.getTime() - (bufferMinutes * 60 * 1000));
        
        // Since both are now in the same reference frame, we can compare directly
        console.log("Event END time (Lithuanian interpreted):", eventInLithuania);
        console.log("Event END time with buffer:", eventWithBuffer);
        console.log("Current time (Lithuanian interpreted):", nowInLithuania);
        console.log("Is past event (class ended + buffer):", eventWithBuffer < nowInLithuania);
    
        // Check if the event is in the past (considering the 10-minute buffer for everyone)
        return eventWithBuffer < nowInLithuania;
        
      } catch (error) {
        console.error("Error parsing event time:", error);
        return false; // Default to not past if parsing fails
      }
  }
    const formatDateTime = (datetime) => {
        let parts = datetime.split(" ");
        let datePart = parts[0];
        let timePart = parts[1];
        let dayPart = parts[2];

        let formattedDate = `${dayPart}<br>${datePart}`;
            return { timePart, formattedDate };
    };
    function formatEventTime(eventTime) {
      // Extract the date and time parts using a regular expression
      const match = eventTime.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2})/);

      if (!match) {
          console.error("Invalid date format:", eventTime);
          return null; // Return null if the format doesn't match the expected pattern
      }

      const datePart = match[1]; // e.g., "2024-09-06"
      const timePart = match[2]; // e.g., "14:00"

      // FIXED: Since displayTime contains START time, but we need to check END time,
      // add 1 hour to get the actual class end time
      const [hours, minutes] = timePart.split(':').map(Number);
      const startTime = new Date(`${datePart}T${timePart}:00`);
      const endTime = new Date(startTime.getTime() + (60 * 60 * 1000)); // Add 1 hour
      
      // Format back to ISO string format for consistency
      const endHours = endTime.getHours().toString().padStart(2, '0');
      const endMinutes = endTime.getMinutes().toString().padStart(2, '0');
      
      return `${datePart}T${endHours}:${endMinutes}:00`;
    }

    const fetchUserRole = async () => {
      const token = localStorage.getItem('jwtToken')
      console.log("This is the token:)")
      console.log(token)
      try {
        const response = await fetch('/studentplayground/isUserTeacher/', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          isUserTeacher = data.isUserTeacher
          console.log("THis is what returns for isUserTeacher:")
          console.log(isUserTeacher)// Assuming the role is returned in the JSON as { "role": "Teacher" }
        } else {
            if (response.status === 401) {
                // If response is 401 Unauthorized, redirect to login
                alert('Reikia prisijungti iš naujo.');
                localStorage.removeItem('jwtToken'); // Optional: Clear any stored tokens
                window.location.href = '#/about'; // Redirect to login page
            } else {
                // Handle other errors
                alert('Error submitting form!');
            }
        }
      } catch (error) {
        console.error("Failed to fetch user role:", error);
        return null;
      }
    };

    const fetchEvents = async () => {
      const token = localStorage.getItem('jwtToken'); // Retrieve token from localStorage

      isLoadingEvents = true;
      scheduleError = '';

      if (!token) {
        console.error('No JWT token found. User might not be logged in.');
        scheduleError = 'Nepavyko įkelti pamokų. Prisijunkite iš naujo.';
        isLoadingEvents = false;
        return;
      }

      try {
        console.log("THis is within the picking, this is Teacher :))")
        console.log(isUserTeacher)
        // Determine the URL based on the user's role
        const url = isUserTeacher
          ? `/teacher_playground/teacherSchedge/?filter=${currentFilter}`
          : `/studentplayground/studentList/?filter=${currentFilter}`;

        console.log("THis is the url we trynna get to:")
        console.log(url)

        // Make the request
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          events = data.events;
        } else {
            scheduleError = 'Nepavyko įkelti pamokų. Bandykite dar kartą.';
            if (response.status === 401) {
                // If response is 401 Unauthorized, redirect to login
                alert('Reikia prisijungti iš naujo.');
                localStorage.removeItem('jwtToken'); // Optional: Clear any stored tokens
                window.location.href = '#/about'; // Redirect to login page
            } else {
                // Handle other errors
                alert('Error submitting form!');
            }
        }
      } catch (error) {
        console.error("Failed to fetch events:", error);
        scheduleError = 'Nepavyko įkelti pamokų. Patikrinkite interneto ryšį ir bandykite dar kartą.';
      } finally {
        isLoadingEvents = false;
      }
    };


  // Handle filter change event from FilterButtons component
  const handleFilterChange = async (event) => {
        if (notesEventId && !await notesPanel.requestClose()) return;
        currentFilter = event.detail.filter; // Update the filter
        fetchEvents(); // Fetch new events based on the filter
    };

// Fetch events when the component is mounted
onMount(async () => {
  await fetchUserRole();
  console.log("THis is teacher value:D")
  console.log(isUserTeacher)
  fetchEvents();
  
  // Fetch unaccepted requests count for teachers
  if (isUserTeacher) {
    fetchUnacceptedRequestsCount();
  }
  
  // Fetch unaccepted reschedule requests count for all users
  fetchUnacceptedRescheduleRequestsCount();
  
  // Check for URL parameters to auto-switch tabs
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('tab') === 'reschedule' || window.location.hash.includes('reschedule')) {
    activeTab = 'reschedule-requests';
  } else if (urlParams.get('tab') === 'registration' || window.location.hash.includes('registration')) {
    activeTab = 'registration-requests';
  }
})

async function handleClassJoin(event) {
  try {
    const token = localStorage.getItem('jwtToken');
    // Track attendance first
    const response = await fetch(`/studentplayground/track-attendance/${event.id}/`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to track attendance');
    }

    const data = await response.json();
    // Redirect to the actual meeting link
    window.open(data.redirect_url, '_blank');
  } catch (error) {
    console.error('Error tracking attendance:', error);
    // If tracking fails, still allow them to join the class
    window.open(event.nuoroda, '_blank');
  }
}
</script>
{#if notesEventId}
  <TeacherPersonalNotesPanel anchorEventId={notesEventId} bind:this={notesPanel} on:close={closePersonalNotes} on:notechange={personalNoteChanged} />
{/if}
    
    <style>
      .cancelled-payable-label { color: #9b4039; font-weight: 700; }
      
      .classcontainer{
        position: relative;
        padding: 15px;
        background-color: #eeebdb;
        display: flex;
        flex-direction: column;
        margin-bottom:15px;
        gap: 10px;
        box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
        border-radius: 8px;
        flex: none;
        color:black;
        align-items: flex-start;

      }

      .personal-notes-trigger { align-self: flex-end; display: inline-flex; align-items: center; gap: 6px; min-height: 36px; padding: 7px 10px; border: 1px solid #9ca28f; border-radius: 6px; background: #faf9f3; color: #34402a; cursor: pointer; }
      .personal-notes-trigger.has-note { background: #dfe8d2; border-color: #50633c; }
      .notes-indicator { width: 7px; height: 7px; border-radius: 50%; background: #50633c; }
      @media (min-width: 1100px) {
        .teacher-schedule.notes-open { width: min(600px, calc(100vw - 608px)); margin-inline: auto; transform: translateX(-280px); }
      }

      .no-classes-message {
        padding: 30px;
        text-align: center;
        background-color: #f8f9fa;
        border-radius: 8px;
        margin: 20px 0;
        box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
      }

      .no-classes-message p {
        color: #6c757d;
        font-size: 16px;
        margin: 0;
        font-weight: 500;
      }

      .reschedule-tab {
        width: 100%;
        margin-top: 10px;
      }

      .reschedule-tab-button {
        width: 100%;
        padding: 15px 20px;
        border: 1px solid #ccc;
        background: white;
        cursor: pointer;
        border-radius: 8px;
        font-size: 16px;
        font-weight: bold;
        transition: background-color 0.3s, color 0.3s;
        color: #000000;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        position: relative;
      }

      .reschedule-tab-button.active {
        background-color: #fab45a;
        color: black;
        border-color: #fab45a;
      }

      .reschedule-tab-button:hover {
        background-color: #fab45a;
        color: black;
      }

      .teacher-registration-tab {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 10px;
      }

      .teacher-registration-button {
        width: 100%;
        padding: 15px 20px;
        border: 1px solid #ccc;
        background: white;
        cursor: pointer;
        border-radius: 8px;
        font-size: 16px;
        font-weight: bold;
        transition: background-color 0.3s, color 0.3s;
        color: #000000;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        position: relative;
      }

      .teacher-registration-button:hover {
        background-color: #fab45a;
        color: black;
      }

      .count-badge {
        background-color: #dc3545;
        color: white;
        border-radius: 50%;
        padding: 4px 8px;
        font-size: 12px;
        font-weight: bold;
        min-width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
      }
      
    </style>
    
  
    <div class="teacher-schedule" class:notes-open={notesEventId !== null}>
    <NavBarReusable label="Tvarkaraštis" />

    <!-- Teacher registration button - shown only for teachers -->
    {#if isUserTeacher && activeTab === 'schedule'}
        <div class="teacher-registration-tab">
            <button 
                class="teacher-registration-button"
                on:click={() => switchTab('registration-requests')}
            >
                <span>KLASIŲ REGISTRACIJOS</span>
                {#if unacceptedRequestsCount > 0}
                    <span class="count-badge">{unacceptedRequestsCount}</span>
                {/if}
            </button>
        </div>
    {/if}

    {#if activeTab === 'schedule'}
        <FilterButtons 
            currentFilter={currentFilter} 
            beforeChange={async () => !notesEventId || await notesPanel.requestClose()}
            on:filterChange={handleFilterChange} />
    {/if}

    {#if activeTab !== 'registration-requests'}
        <div class="reschedule-tab">
            <button 
                class="reschedule-tab-button {activeTab === 'reschedule-requests' ? 'active' : ''}"
                on:click={() => switchTab(activeTab === 'reschedule-requests' ? 'schedule' : 'reschedule-requests')}
            >
                <span>{activeTab === 'reschedule-requests' ? 'ATGAL Į TVARKARAŠTĮ' : 'PAMOKŲ PAKEITIMAI'}</span>
                {#if unacceptedRescheduleRequestsCount > 0 && activeTab !== 'reschedule-requests'}
                    <span class="count-badge">{unacceptedRescheduleRequestsCount}</span>
                {/if}
            </button>
        </div>
    {/if}

    <!-- Back button for registration requests -->
    {#if activeTab === 'registration-requests'}
        <div class="reschedule-tab">
            <button 
                class="reschedule-tab-button active"
                on:click={() => switchTab('schedule')}
            >
                ATGAL Į TVARKARAŠTĮ
            </button>
        </div>
    {/if}

    {#if activeTab === 'schedule'}
        <div class="classSection">
          {#if isLoadingEvents}
            <div class="no-classes-message">
              <p>Kraunamos pamokos…</p>
            </div>
          {:else if scheduleError}
            <div class="no-classes-message" role="alert">
              <p>{scheduleError}</p>
            </div>
          {:else if events.length === 0}
            <div class="no-classes-message">
              <p>Pamokų nerasta</p>
            </div>
          {:else}
            {#each events as event}
              <div class="classcontainer {isPastEvent(event.laikasDisp) ? 'past-event' : 'upcoming-event'}">
                {#if isUserTeacher}
                  <button type="button" class="personal-notes-trigger" class:has-note={event.has_personal_note}
                    aria-label={`Asmeniniai užrašai: ${event.pamoka}`} title={event.has_personal_note ? 'Peržiūrėti asmeninius užrašus' : 'Pridėti asmeninius užrašus'}
                    on:click={click => openPersonalNotes(event, click.currentTarget)}>
                    <i class="fa-solid fa-pencil" aria-hidden="true"></i>
                    {#if event.has_personal_note}<span class="notes-indicator" aria-hidden="true"></span>{/if}
                  </button>
                {/if}
                <!-- Render the class details -->
                {#if event.cancelled_payable}
                  <p class="cancellation-status cancelled-payable-label" role="status">{isUserTeacher ? 'Atšaukta – apmokama' : 'Atšaukta nesilaikant atšaukimo sąlygų'}</p>
                  {#if !isUserTeacher}<p>Pamoka apmokama</p>{/if}
                {/if}
                {#each event.participants || [] as participant}
                  {#if participant.participation_status === 'cancelled_payable' && !event.cancelled_payable}
                    <p class="cancellation-status cancelled-payable-label">{participant.name} – {isUserTeacher ? 'Atšaukė – apmokama' : 'Atšaukta nesilaikant atšaukimo sąlygų – apmokama'}</p>
                  {/if}
                {/each}
                <ClassName name={event.pamoka} />
                <TeacherName teacher={event.mokytojas}/>
                <TimeShower 
                  time={formatDateTime(event.laikasDisp).timePart} 
                  date={formatDateTime(event.laikasDisp).formattedDate} 
                />
                
                <!-- Show students with grades for teachers -->
                {#if isUserTeacher && event.students}
                  <StudentsWithGradesComponent students={event.students} />
                {/if}
      
                {#if event.can_participate !== false}
                {#if !isPastEvent(event.laikasDisp)}
                  <!-- Render components for upcoming events -->
                  
                  <ButtonToJoinClass 
                      link={event.nuoroda} 
                      classId={event.id}
                      label="Jungtis į pamoką" 
                  />
                  <RescheduleButton classId={event.id} label="Keisti rezervaciją" />
                {/if}

                {#if isPastEvent(event.laikasDisp) || (isUserTeacher && hasClassStarted(event.laikasDisp))}
                  <!-- Teachers can leave feedback from class start alongside the existing actions. -->
                  {#if event.note === 'nėra atsiliepimo' || !event.note}
                      <ButtonToComment classId={event.id} classStart={isUserTeacher ? event.laikasRaw : null} label="Palikti Atsiliepimą"></ButtonToComment>
                  {:else}
                      <ButtonToComment classId={event.id} classStart={isUserTeacher ? event.laikasRaw : null} label="Koreguoti Atsiliepimą" buttonClass="koregouti"></ButtonToComment>
                  {/if}
                {/if}
                {/if}
              </div>
          {/each}
          {/if}
        </div>
    {:else if activeTab === 'reschedule-requests'}
        <RescheduleRequestsContent />
    {:else if activeTab === 'registration-requests'}
        <TeacherRegistrationRequestsComponent />
    {/if}
    </div>
